import { Popover, Transition } from '@headlessui/react'
import { Fragment } from 'react'
import React from 'react'
import MenuItem from 'components/Layout/Header/Navigation/MenuItem'
import { INavigationMenu } from 'components/Layout/Header/Navigation'
import { Link } from 'gatsby'
import { P } from 'components/typography/Paragraph'

interface Props {
	menu: INavigationMenu
}

export default function NavigationMenu({ menu }: Props) {
	return (
		<div className="w-full max-w-max px-4">
			{menu.menuItems && menu.menuItems?.length > 0 ? (
				<Popover className="relative">
					{({ open }) => (
						<>
							<Popover.Button
								className={`${
									open ? 'border-white' : 'border-transparent'
								} inline-flex items-center rounded-md border px-3 py-2 text-base font-medium text-white transition-all focus:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-opacity-75`}
							>
								<span>{menu.name}</span>
								<svg xmlns="http://www.w3.org/2000/svg" className="ml-2 h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
									<path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
								</svg>
							</Popover.Button>
							<Transition
								as={Fragment}
								enter="transition ease-out duration-200"
								enterFrom="opacity-0 translate-y-1"
								enterTo="opacity-100 translate-y-0"
								leave="transition ease-in duration-150"
								leaveFrom="opacity-100 translate-y-0"
								leaveTo="opacity-0 translate-y-1"
							>
								<Popover.Panel className="absolute left-1/2 z-[99] mt-3 w-screen max-w-sm -translate-x-1/2 transform px-4 sm:px-0 lg:max-w-sm">
									<div className={`overflow-hidden rounded-lg border-b-[6px] ${menu.colors?.border} shadow-lg ring-1 ring-black ring-opacity-5`}>
										<div className="relative bg-white p-7 pb-4">
											{menu.menuItems && menu.menuItems.map((item) => <MenuItem key={item.name} item={item} colors={menu.colors} />)}
										</div>
									</div>
								</Popover.Panel>
							</Transition>
						</>
					)}
				</Popover>
			) : (
				<Link to={menu.href ? menu.href : ''} className="hover:no-underline">
					<button className="inline-flex items-center rounded-md border border-transparent px-3 py-2 text-base font-medium text-white transition-all focus:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-opacity-75">
						<span>{menu.name}</span>
					</button>
				</Link>
			)}
		</div>
	)
}
